/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable default-param-last */
/* eslint-disable no-case-declarations */
const initialState = {
  permissionsUserSelect: [],
};

const permissionUserSelect = (state = initialState, action) => {
  switch (action.type) {
    case 'HANDLE-PERMISSIONS-USER-SELECT':
      return {
        permissionsUserSelect: action.payload.domain_permissions,
      };
    case 'HANDLE-EMPTY-PERMISSIONS':
      return { permissionsUserSelect: [] };

    default:
      return state;
  }
};

export default permissionUserSelect;
